<template>
    <section class="app-main">
        <div class="top-bar">
            <el-input placeholder="搜索" v-model="search" @change="getData()"  style="width:300px;">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
        </div>
        <el-card>
            <el-table :data="tableData" v-loading="table_load" height="630" style="width: 100%">
                <el-table-column  prop="corporate_name"    label="企业名称"   align="center" show-overflow-tooltip></el-table-column>
                <el-table-column  prop="batch"    label="姓名"   align="center">
                    <template slot-scope="scope">
                        <el-link type="info">{{scope.row.surname}} {{scope.row.name}} </el-link>
                    </template>
                </el-table-column>
                <el-table-column  prop="email"    label="邮箱"    align="center" > </el-table-column>
                <el-table-column  prop="phone"    label="电话"     align="center"></el-table-column>
                <el-table-column  prop="refusal_reasons"    label="拒绝理由"     align="center"></el-table-column>
            </el-table>
            <el-pagination background layout="prev, pager, next, jumper" :current-page.sync="page" style="padding:10px" :total="total"  @current-change="loadPage"></el-pagination>
        </el-card>
    </section>
</template>
<script>
import { partner } from '@/api/merchant.js'
export default {
    data() {
        return {
            search: '',
            page:1,
            total:0,
            tableData:[],
        }
    },
    methods: {
        getData(){
            let params = { 
                page: this.page,
                audit_status: 3
            }
            if(this.search != '') {
                params.keywords = this.search
            }
            partner(params).then(res => {
                if(res){
                    this.tableData = res.data.data
                    this.total = res.data.total
                }
            })
        },
        loadPage(page){
            this.page = page;
            this.getData()
        },
    },
    created(){
        this.getData()
    },
    activated() {
        this.getData()
    },
}
</script>



